import "core-js/modules/es.function.name.js";
import React from 'react';
import Button from "../../Common/FooterButton";
import { Keys } from "../../Common/Constants";
import { useCefEventTracker } from "../../Hooks/useCefEventTracker";
import { CefEvent, CefEventName, Platform, Reason } from "../../../../EventTracker";
import { isCountryFieldValid } from "../../Utilities/Validators";
export var FooterButton = function FooterButton(_ref) {
  var countriesData = _ref.countriesData,
    nationality = _ref.nationality,
    pushLocation = _ref.pushLocation,
    setErrorMessage = _ref.setErrorMessage;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var onClick = function onClick() {
    var validationData = isCountryFieldValid(nationality === null || nationality === void 0 ? void 0 : nationality.name, countriesData);
    if (!validationData[0]) {
      setErrorMessage(validationData[1]);
      trackEvent(CefEvent(CefEventName.FailedToNavigateToNextStep, Platform.Mobile, {
        incomplete_fields: Keys.Application.nationality,
        reason: Reason.EmptyField
      }));
    } else {
      pushLocation();
    }
  };
  return /*#__PURE__*/React.createElement(Button, {
    label: "Next",
    onClick: onClick
  });
};